$(function() {
  $('.instructor-modal-target').on('click', function(event) {
    event.stopPropagation()

    const name = $(this).data('name')
    const post = $(this).data('post')
    const text = $(this).data('text')
    const mainImage = $(this).data('main-image')
    const logoImage = $(this).data('logo-image')
    const bookFlag = $(this).data('book-flag')
    const addClass = $(this).data('class')

    $('#instructorModalLogo').attr('src', logoImage)
    $('#instructorModalLogo').attr('alt', name)
    $('#instructorModalLogo').addClass(addClass)
    $('#instructorModalPost').text(post)
    $('#instructorModalName').text(name)

    if(addClass === 'terry' || addClass === 'kato' || addClass === 'hirai' || addClass === 'sasaki-daisuke' || addClass === 'tsuji' || 'kosaka' || 'kume' || 'wada' || 'morita' ) {
      $('#instructorModalName').addClass('special-guest')
    } else {
      $('#instructorModalName').removeClass('special-guest')
    }

    $('#instructorModalText').text(text)
    $('#instructorModalImage').attr('src', mainImage)

    if(bookFlag) {
      $('#instructorModalBookWrapper').addClass('active')
      const bookImage = $(this).data('book-image')
      $('#instructorModalBookImage').attr('src', bookImage)
    }

    $('#instructorModal').addClass(addClass)
    $('#instructorModal').addClass('active')
    $('body').addClass('no-scroll')
  })

  $('#instructorModalClose').on('click', function() {
    $('#instructorModal').removeClass('active')
    $('body').removeClass('no-scroll')
    $('#instructorModalBookWrapper').removeClass('active')
    $('#instructorModalLogo').removeClass()
    $('#instructorModalLogo').addClass('Modal__logo-image')
  })

  // モーダルのコンテンツ部分でクリックイベントが親要素へ伝播しないようにする
  $('.Modal__wrapper').on('click', function(event) {
    event.stopPropagation(); // イベントの伝播を停止
  });


  $('.Modal__mask').on('click', function() {
    $('#instructorModal').removeClass('active')
    $('body').removeClass('no-scroll')
    $('#instructorModalBookWrapper').removeClass('active')
    $('#instructorModalLogo').removeClass()
    $('#instructorModalLogo').addClass('Modal__logo-image')
    $('#venueModal').removeClass('active')
  })

  $('.Information__modal-button').on('click', function() {
    const imagePath = $(this).data('image-path')

    $('#venueModalImage').attr('src', imagePath)
    $('#venueModal').addClass('active')
    $('body').addClass('no-scroll')
  })

  $('#venueModalClose').on('click', function() {
    $('#venueModal').removeClass('active')
    $('body').removeClass('no-scroll')
  })
})

